import { render } from "./SubMenu.vue?vue&type=template&id=4d53e5cc"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Navigation/SubMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d53e5cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d53e5cc', __exports__)) {
    api.reload('4d53e5cc', __exports__)
  }
  
  module.hot.accept("./SubMenu.vue?vue&type=template&id=4d53e5cc", () => {
    api.rerender('4d53e5cc', render)
  })

}


export default __exports__